import moment from "moment";
const criarPeriodoPadrao = () => ({
  start: moment().startOf("day").add(8, "hours"),
  end: moment().startOf("day").add(20, "hours"),
});

export const criarSemanalPadrao = () => ({
  1: [criarPeriodoPadrao()],
  2: [criarPeriodoPadrao()],
  3: [criarPeriodoPadrao()],
  4: [criarPeriodoPadrao()],
  5: [criarPeriodoPadrao()],
  6: [],
  0: [],
});

export const formatarPeriodosParaAPI = (periodosObj) => {
  const formatado = {};
  Object.keys(periodosObj).forEach((dia) => {
    formatado[dia] = periodosObj[dia].map((p) => ({
      start: p.start.format("HH:mm:ss"),
      end: p.end.format("HH:mm:ss"),
    }));
  });
  return formatado;
};

export const formatarExcecoesParaAPI = (excecoes) =>
  excecoes.map((exc) => ({
    data: exc.data.format("YYYY-MM-DD"),
    periodos: exc.periodos.map((p) => ({
      start: p.start.format("HH:mm:ss"),
      end: p.end.format("HH:mm:ss"),
    })),
    motivo: exc.motivo || "",
    bloqueado: exc.bloqueado || false,
  }));

export const formatarPeriodosEspeciaisParaAPI = (periodosEspeciais) =>
  periodosEspeciais.map((periodo) => ({
    nome: periodo.nome,
    dataInicio: periodo.dataInicio.format("YYYY-MM-DD"),
    dataFim: periodo.dataFim.format("YYYY-MM-DD"),
    horarioPadrao: formatarPeriodosParaAPI(periodo.horarioPadrao),
  }));
